import "./Css/DefaultPaper.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import API_BASE from "../config/api";

const ExamPreview = () => {
  const navigate = useNavigate();
  const { paperId } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  const [examInfo, setExamInfo] = useState({});
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const targetPaperId = searchParams.get("targetId");

  console.log(targetPaperId, 'target')
  console.log(paperId, 'paperId')

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/Papers/${paperId}/preview`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
            }
          }
        );

        const data = res.data;

        setExamInfo({
          name: data.softwareName,
          class: data.standardName,
          subject: data.subjectName
        });

        setQuestions(
          data.questions.map(q => ({
            id: q.displayOrder,
            question: q.questionText,
            options: [q.optionA, q.optionB, q.optionC, q.optionD]
          }))
        );
      } catch (err) {
        console.error(err);
        alert("Failed to load preview");
      } finally {
        setLoading(false);
      }
    };

    fetchPreview();
  }, [paperId]);

  const filteredData = questions.filter((q) =>
    q.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    q.id.toString().includes(searchQuery)
  );


  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePreviewClick = () => {
    navigate(`/dashboard/previewpaper/${paperId}`);
  };
  return (
    <div className="exam-pagee">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt;परीक्षा तयार करा &gt;&gt;By Default &gt;&gt; <span>View</span>
        </h3>

        <div className="edit-btnn">
          <button
            className="builder-container-preview-btn"
            onClick={handlePreviewClick}
          >
            प्रिव्ह्यू
          </button>
        </div>

        <button
          className="builder-container-preview-btn"
          onClick={async () => {
            if (!targetPaperId) return alert("Target paper missing");
            try {
              await axios.post(
                `${API_BASE}/api/Papers/confirm-default`,
                {
                  templatePaperId: paperId,
                  targetPaperId: targetPaperId,
                  publishNow: true
                },
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
                  }
                }
              );

              alert("Paper created successfully");
              navigate(`/dashboard/exammanagment`);
            } catch (err) {
              console.error(err);
              alert("Failed to confirm paper");
            }
          }}
        >
          Confirm Paper
        </button>


        <button
          className="builder-container-preview-btn"
          onClick={async () => {
            try {
              const res = await axios.post(
                `${API_BASE}/api/Papers/${paperId}/clone`,
                { publishNow: false },
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
                  }
                }
              );

              alert("Paper cloned");
              navigate(`/dashboard/exammanagment`);
            } catch (err) {
              console.error(err);
            }
          }}
        >
          Clone Paper
        </button>
      </div>

      {/* Exam Info */}
      <div className="exam-info">
        <div><b>परीक्षेचे नाव :</b> {examInfo.name}</div>
        <div><b>इयत्ता :</b> {examInfo.class}</div>
        <div><b>विषय :</b> {examInfo.subject}</div>
      </div>

      {/* Questions */}
      <div className="question-section">
        <h3>एकुण जोडलेले प्रश्न</h3>

        {loading ? (
          <p>Loading questions...</p>
        ) : paginatedData.length === 0 ? (
          <p>No questions found</p>
        ) : (
          paginatedData.map((q) => (

            <div className="question-card" key={q.id}>
              <p className="question-text">
                {(currentPage - 1) * rowsPerPage + q.id})
                {q.question}
              </p>
              <ul className="optionsu">
                {q.options.map((opt, index) => (
                  <li key={index}>
                    {index + 1}) {opt}
                  </li>
                ))}
              </ul>
            </div>
          )
          ))}
      </div>
      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamPreview;
